import { DrawerObject } from '@/components/drawer/drawer.types';
import { FormBuilderComponent } from '@/components/form-builder/form-builder.component';
import { DynamicForm } from '@/components/form-builder/form-builder.types';
import { FundingSourceRepository } from '@/store/funding-source-state/funding-source-state.repository';

interface getFundingSourceAddDrawerObjectProps {
  store: FundingSourceRepository;
  formObject: DynamicForm;
  toggleVisibility?: () => void;
  action?: () => void;
}

export const getFundingSourceAddDrawerObject = ({
  store,
  formObject,
  toggleVisibility,
  action,
}: getFundingSourceAddDrawerObjectProps): DrawerObject => {
  return {
    title: 'fundingSources.add.title',
    description: '',
    component: {
      outlet: FormBuilderComponent,
      props: { formObject },
    },
    onHide: () => {
      store?.reset();
    },
    actions: [
      {
        label: 'common.add',
        onClick: () => action?.(),
      },
      {
        label: 'common.cancel',
        onClick: () => {
          toggleVisibility?.();
          store?.reset();
        },
        variant: 'secondary',
      },
    ],
  };
};
